/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Language from "@material-ui/icons/Language";
import MoreIcon from "@material-ui/icons/MoreVert";
import Settings from "@material-ui/icons/Settings";
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FontDownloadIcon from '@material-ui/icons/FontDownload';
import CompareIcon from '@material-ui/icons/Compare';
import DisplayIcon from '@material-ui/icons/ArtTrack';

const styles = theme => ({
  root: {
    width: "100%"
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  appBar: {
    backgroundColor: "#4caf50",
    color:"white",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  }
});

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      anchorElOptions: null,
      mobileMoreAnchorEl: null,
      isDefault:
          this.props.dataset === "beer" ||
          this.props.dataset === "flavia" ||
          this.props.dataset === "iris" ||
          this.props.dataset === "glass" ||
          this.props.dataset === "wine" ||
          this.props.dataset === "vehicle" ||
          this.props.dataset === "ACB" ||
          this.props.dataset === "PIMA" ||
          this.props.dataset === "OULAD" ||
          this.props.dataset === "bank",
    };
  }

  handleOptionsMenuOpen = event => {
    this.setState({ anchorElOptions: event.currentTarget });
  };

  handleLanguageMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  handleMenuOptionsClose = event => {
    this.setState({ anchorElOptions: null });
    if (this.props.algorithm !== event.target.id && event.target.id) {
      this.props.handleAlgorithmChange(event.target.id);
    }
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  handleMobileMenuOpen = event => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };
  handleConfigClick = (event) =>{
    this.props.classifierDontExist("J48")
    this.props.goToBuilder();
  }
  handleCompareClick = (event) =>{
    this.props.goToComparation();
  }
  handleDisplayClick = (event) =>{
    this.props.goToDisplay();
  }
  handleCloseLanguage = event => {
    if (this.props.language.id !== event.target.id) {
      this.props.handleLanguageChange(event.target.id);
    }
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  render() {
    const { anchorEl, anchorElOptions, mobileMoreAnchorEl } = this.state;
    const { classes } = this.props;
    const isMenuOpen = Boolean(anchorEl);
    const isMenuOptionsOpen = Boolean(anchorElOptions);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const renderMenuOptions = (
      <Menu
        anchorEl={anchorElOptions}
        open={isMenuOptionsOpen}
        onClose={this.handleMenuOptionsClose}
      >
        <MenuItem id="J48" onClick={this.handleMenuOptionsClose}>
          J48
        </MenuItem>
        <MenuItem id="REPTree" onClick={this.handleMenuOptionsClose}>
          REPTree
        </MenuItem>
        <MenuItem id="RandomTree" onClick={this.handleMenuOptionsClose}>
          RandomTree
        </MenuItem>
        <MenuItem id="FuzzyHoeffdingDecisionTree" onClick={this.handleMenuOptionsClose}>
          FuzzyHoeffdingDecisionTree
        </MenuItem>
        <MenuItem id="FURIA" onClick={this.handleMenuOptionsClose}>
          FURIA
        </MenuItem>
        <MenuItem id="RandomForest" onClick={this.handleMenuOptionsClose}>
          RandomForest
        </MenuItem>
      </Menu>
    );

    const renderMenuLanguage = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={this.handleMenuClose}
      >
        <MenuItem id="en" onClick={this.handleCloseLanguage}>
          {this.props.language.labels[this.props.language.id].english}
        </MenuItem>
        <MenuItem id="es" onClick={this.handleCloseLanguage}>
          {this.props.language.labels[this.props.language.id].spanish}
        </MenuItem>
        <MenuItem id="gl" onClick={this.handleCloseLanguage}>
          {this.props.language.labels[this.props.language.id].galician}
        </MenuItem>
      </Menu>
    );

    const renderMobileMenu = (
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMobileMenuOpen}
        onClose={this.handleMobileMenuClose}
      >
        <MenuItem onClick={this.handleLanguageMenuOpen}>
          <IconButton color="inherit">
            <Language />
          </IconButton>
          <p>Language</p>
        </MenuItem>
        {this.props.algorithm && (
          <MenuItem onClick={this.handleOptionsMenuOpen}>
            <IconButton color="inherit">
              <FontDownloadIcon />
            </IconButton>
            <p>Algorithm</p>
          </MenuItem>
        )}
        {this.props.algorithm && (
            <MenuItem onClick={this.handleOptionsMenuOpen}>
              <IconButton color="inherit">
                <Settings />
              </IconButton>
              <p>Configuration</p>
            </MenuItem>
        )}
      </Menu>
    );

    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <Link className="link" to="/">
            <HomeRoundedIcon style={{ fontSize: 50 }}  />
            </Link>
            <Link className="link" to="/">
              <Typography variant="h6" color="inherit" noWrap>
              ExpliClas
              </Typography>
            </Link>
            <div className={classes.grow} />
            {this.props.algorithm ? (
              <div className={classes.sectionDesktop}>
                <IconButton
                  aria-owns={isMenuOptionsOpen ? "material-appbar" : null}
                  aria-haspopup="true"
                  onClick={this.handleOptionsMenuOpen}
                  color="inherit"
                >
                  {this.props.algorithm} <ExpandMoreIcon />
                </IconButton>
                {!this.state.isDefault &&
                <IconButton
                    aria-owns={isMenuOptionsOpen ? "material-appbar" : null}
                    aria-haspopup="true"
                    onClick={this.handleConfigClick}
                    color="inherit"
                >
                  CONF{" "}<Settings/>
                </IconButton>
                }
                <IconButton
                    aria-owns={isMenuOptionsOpen ? "material-appbar" : null}
                    aria-haspopup="true"
                    onClick={this.handleCompareClick}
                    color="inherit"
                >
                  COMPARE{" "}<CompareIcon/>
                </IconButton>
              </div>
            ) : (
              ""
            )}
            <div className={classes.sectionDesktop}>
              {this.props.comparationMode &&
              <IconButton
                  aria-owns={isMenuOptionsOpen ? "material-appbar" : null}
                  aria-haspopup="true"
                  onClick={this.handleDisplayClick}
                  color="inherit"
              >
                DISPLAY{"  "}<DisplayIcon fontSize={"large"}/>
              </IconButton>
              }
              <IconButton
                aria-owns={isMenuOpen ? "material-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleLanguageMenuOpen}
                color="inherit"
              >
                {this.props.language.id} <Language />
              </IconButton>

            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-haspopup="true"
                onClick={this.handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMenuOptions}
        {renderMenuLanguage}
        {renderMobileMenu}
      </div>
    );
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NavBar);
